<script>
    import Modal from "sv-bootstrap-modal";
    import Tooltip from "./Tooltip.svelte";
    import Util from "../util";
    //
    export let disabled = false;
    export let open = false;
    export let onSave = () => {};
    export let project = {};
    export let showChartAB = false;
    export let showChartLA = false;
    export let showChartLB = false;
    export let showData = false;
    export let displayExtensionMessage = undefined;

    let imageFile = undefined;
    let maxSizeClass = "text-secondary";
    let edit = {};
    //
    const classPill = "btn btn-sm btn-chart-report mr-3";
    const classPillSelected = `${classPill} btn-outline-blue`;
    const classPillDefault = `${classPill} btn-outline-secondary`;
    //
    const onCancel = () => {
        edit = Object.assign({}, project);
        open = false;
    };
    const onOpened = () => {
        edit = Object.assign({}, project);
    }
    const onSubmit = async () => {
        Object.assign(project, edit);
        await onSave({ project, imageFile, showChartLA, showChartAB, showChartLB, showData });
        open = false;
    };
    const validateImage = (event) => {
        let file = event.target.files[0];
        let size = file.size;
        let name = file.name;

        if (size > 2097152) {
            maxSizeClass = "text-danger";
            setTimeout(() => {
                maxSizeClass = "text-secondary";
            }, 2000);
            return;
        } else {
            let fileExtension = name.split(".").pop();
            let validExtension = ["jpeg", "png", "jpg"];
            if (validExtension.includes(fileExtension)) {
                imageFile = event.target.files[0];
                return;
            }
            displayExtensionMessage = "display:block";
            setTimeout(() => {
                displayExtensionMessage = "display:none";
            }, 2000);
        }
    };

    let isOpen = false;
</script>

<Modal bind:open dialogClasses="modal-dialog-centered" {onOpened}>
    <Tooltip bind:isOpen style="top: 110px; left: 120px; display: none;" position="right" number="1" title="" text="Project Type: What type of construction is the unit going into, e.g. curtain wall versus punched opening, etc." />
    <Tooltip bind:isOpen style="top: 445px; left: 275px; display: none;" position="top" number="2" title="" text="Show Data: Include rows of color data, Unit #, Delta values from Target, Date, and Ticket number in printed report" />
    <Tooltip bind:isOpen style="top: 360px; left: -50px; display: none;" position="top" number="3" title="">
        <br/>
        <p>Show L*a*:   a* + = red, - = green</p>
        <p style="margin-left: 30px;">
            L*  + = lighter, - = darker
        </p>
        <p>Show a*b*:  a* + = red, - = green</p>
        <p style="margin-left: 30px;">
            b*  + = yellow, - = blue
        </p>
        <p>Show L*b*:  L*  + = lighter, - = darker</p>
        <p style="margin-left: 30px;">
            b*  + = yellow, - = blue
        </p>
    </Tooltip>
    <div class="modal-body">
        <div class="row">
            <div class="col-12 text-end">
                <button type="button" class="btn-close" on:click={() => (open = false)} aria-label="Close" />
            </div>
        </div>
        <div class="row">
            <div class="col-9" style="display: flex; align-items: center;">
                <p class="text-black fw-bold fs-6">Glass Color - Customize Print</p>
            </div>
            <div class="col-3">
                <div
                    class="help-link align-right HelpToggle"
                    data-display-help="true"
                    on:click|stopPropagation={() => isOpen = true}>
                    <span>
                        <div class="div-help-text">Help&nbsp;<img src={Util.apiSegment + "/Images/help-icon.png"} alt="" /></div>
                    </span>
                    <div class="clearfix" />
                </div>
            </div>
            <div class="col-12">
                <form>
                    <div class="form-group row mt-3">
                        <label for="staticEmail" class="col-sm-3 col-form-label">Project Name</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control form-control-sm"
                                bind:value={edit.Name}
                                maxlength="100"
                                {disabled} />
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <label for="inputPassword" class="col-sm-3 col-form-label">Project Type</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control form-control-sm"
                                bind:value={edit.Type}
                                maxlength="100"
                                {disabled} />
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <label for="inputPassword" class="col-sm-3 col-form-label">Fabricator</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control form-control-sm"
                                bind:value={edit.Fabricator}
                                maxlength="100"
                                {disabled}  />
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <label for="inputPassword" class="col-sm-3 col-form-label">Glazer</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control form-control-sm"
                                bind:value={edit.Glazer}
                                maxlength="100"
                                {disabled}  />
                        </div>
                    </div>
                    <div class="form-group row mt-3">
                        <label for="inputPassword" class="col-sm-3 col-form-label">Project Details</label>
                        <div class="col-sm-9">
                            <textarea class="form-control form-control-sm" rows="3"
                                bind:value={edit.Details} maxlength="1000"
                                {disabled} />
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row mt-3">
            <div class="d-grid gap-2">
                <button
                    on:click={() => {
                        if (!disabled)
                            document.getElementById("fileImage").click();
                    }}
                    type="button"
                    class="btn btn-block btn-file"
                >
                    <span>Click here to upload your logo</span>
                    <span class="text-info"> format.png </span>
                    <br />
                    <span class={maxSizeClass}>Maximum 2MB</span>
                    <br hidden={!imageFile} />
                    <span hidden={!imageFile} class={maxSizeClass}>
                        {imageFile ? imageFile.name : ""}
                    </span>
                    <br />
                    <span class="text-danger" style={displayExtensionMessage}>Only .png and .jpg extension alowed </span>
                </button>
                <input type="file" id="fileImage" accept=".jpg, .jpeg, .png" on:change={validateImage} hidden />
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <p class="text-gray">Please select the charts to include.</p>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <button type="button" class={showChartAB ? classPillSelected : classPillDefault}
                    on:click={() => disabled ? null : (showChartAB = !showChartAB)}
                    title="Show | Hide chart a*b*">
                    <input type=checkbox checked={showChartAB}>
                    <span>Show a*b*</span>
                </button>
                <button type="button" class={showChartLA ? classPillSelected : classPillDefault}
                    on:click={() => disabled ? null : (showChartLA = !showChartLA)}
                    title="Show | Hide chart L*a*">
                    <input type=checkbox checked={showChartLA}>
                    <span>Show L*a*</span>
                </button>
                <button type="button" class={showChartLB ? classPillSelected : classPillDefault}
                    on:click={() => disabled ? null : (showChartLB = !showChartLB)}
                    title="Show | Hide chart L*b*">
                    <input type=checkbox checked={showChartLB}>
                    <span>Show L*b*</span>
                </button>
                <button type="button" class={showData ? classPillSelected : classPillDefault}
                    on:click={() => disabled ? null : (showData = !showData)}
                    title="Show | Hide entries data">
                    <input type=checkbox checked={showData}>
                    <span>Show data</span>
                </button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 text-end">
                <button type="button" on:click={onCancel}
                    class="btn btn-outline-blue me-md-2 btn-sm"
                    title="Cancel operation">
                    Cancel
                </button>
                {#if !disabled}
                    <button type="button" on:click={onSubmit}
                        class="btn btn-blue text-white btn-sm"
                        title="Save settings">
                        Continue
                    </button>
                {/if}
            </div>
        </div>
    </div>
</Modal>

<style>
    .btn-file {
        border: 2px dashed gray;
    }

    .btn-action:hover {
        cursor: pointer;
    }

    label:hover {
        cursor: default !important;
    }

    .multiselect {
        width: 100%;
    }

    .selectBox {
        position: relative;
    }

    .overSelect {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

    .btn-orange {
        background-color: #e67e22;
    }

    .btn-gray {
        background-color: #e5e7e9;
    }

    .btn-blue {
        background-color: #3cb1d6;
    }

    .btn-outline-blue {
        border-style: solid;
        border-width: 1px;
        background-color: white;
        border-color: #3cb1d6;
        color: #3cb1d6;
    }

    .btn-chart-report {
        border-radius: 4px;
    }

    .btn-chart-report input {
        vertical-align: middle;
    }

    .btn-chart-report span {
        padding: 0px 5px;
    }

    .tbl-gray {
        background-color: #3d4952;
    }

    .a-blue {
        color: #3cb1d6;
    }

    .tbl-noPadding {
        border-collapse: collapse;
    }

    .tbl-black-values {
        font-size: 20px !important;
    }

    .tbl-gray-values {
        font-size: 10px !important;
        color: gray;
    }

    .text-blue {
        color: #1f81a0;
    }

    .text-gray {
        color: gray;
    }

    .modal-footer-report {
        display: block;
    }
</style>
